import { COUNTRY_NULL_VALUE_PROPERTY } from "@constants/verification-transaction-values";
import { AppliedProfileTypes } from "@enums/applied-profile-types";
import { ReferenceDataTypes } from "@enums/reference-data-types";

export const isStringNumber = (value: string) => value ? !isNaN(parseInt(value)) : false;

export const sortStrings = (firstString: string, secondString: string) => {
    const trimmedFS = (firstString || "").trim();
    const trimmedSS = (secondString || "").trim();
    if (firstString === COUNTRY_NULL_VALUE_PROPERTY.label) {
        return -1;
    } else if (secondString === COUNTRY_NULL_VALUE_PROPERTY.label) {
        return 1;
    } else if (trimmedFS && trimmedSS) {
        return trimmedFS.toLowerCase().localeCompare(trimmedSS.toLowerCase());
    } else if (trimmedFS) {
        return -1;
    } else if (trimmedSS) {
        return 1;
    }

    return 0;
};

export const getQueryParamValueFromReferenceDataArray = (referenceDataTypes: Array<ReferenceDataTypes>) => {
    return getQueryParamValueArray(referenceDataTypes);
};

export const getQueryParamValueArray = (types: Array<ReferenceDataTypes | AppliedProfileTypes>) => {
    let queryParamValue = "";
    types.forEach((dataType, index) => {
        queryParamValue += dataType;
        if (index !== types.length - 1) {
            queryParamValue += ",";
        }
    });
    return queryParamValue;
};

export const safelyParseIntFromString = (numberString: string) => {
    return !isNaN(parseInt(numberString)) ? parseInt(numberString, 10) : 0;
};

export const isStringValidNumberRegex = (value: string) => value === "" || (value && /^\d+$/.test(value));

export const isStringValidUrlRegex = (value: string) => value && /^(http|https):\/\/[^ "]+$/.test(value);

export const isStringValidAlphaNumeric = (value: string) => value && /^([a-zA-Z0-9]+)$/.test(value);

export const isStringValidAlphaNumericWithUnderscoreDash = (value: string) => value && /^([a-zA-Z0-9_-]+)$/.test(value);

export const convertDotSeparatedStringToJSONObject = (str: string, defaultVal = {}) => {
    return str.split('.').reduceRight((acc, currentVal) => {
        return {
            [currentVal]: acc
        }
    }, defaultVal)
};

export const convertJSONObjectToDotSeparatedString = (languageFile: { [key: string]: any; }): { [key: string]: string } => {
    const walk = (into: any, obj: any, prefix: Array<string> = []) => {
        Object.entries(obj).forEach(([key, val]) => {
            if (typeof val === "object" && !Array.isArray(val)) walk(into, val, [...prefix, key]);
            else into[[...prefix, key].join(".")] = val;
        });
    }
    const out = {};
    walk(out, languageFile);
    return out;
};
